import PATH from '../paths';

const name = 'SA Property Investors Network';
const key = 'sapin';
const imgUrl = `${ PATH.CDN }/whitelabels/sapin`;
const images = {
  favicon: `${ imgUrl }/favicon.png`,
  logo: `${ imgUrl }/sapin-logo.png`,
  logoPDF: `${ imgUrl }/logo-pdf.png`,
  logoSidebar: `${ imgUrl }/sapin-logo-icon.png`,
  opengraph: false,
  backgrounds: [
    `${ imgUrl }/background.jpeg`
  ],
};

export default {
  name,
  key,
  images,
  stylesheet: `
    /* COLOR VARIABLES +++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    --color-sapin-red: #CE0000;
    --color-sapin-red-bg: #DC050B;
    --color-sapin-grey: #DFDFDF;
    --color-sapin-yellow: #F6B012;



    --color-wp-blue-lighter:          160, 205, 232;
    --color-wp-blue-light:            106, 174, 223;
    --color-wp-blue:                  37, 124, 192;
    --color-wp-blue-dark:             32, 52, 102;
    --color-wp-purple:                97, 61, 151;

    --color-primary:                  var(--color-darker);
    --color-secondary:                var(--color-darker);
    --color-accent:                   var(--color-sapin-red);

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* TYPOGRAPHY ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    --color-link:                     rgb(var(--color-wp-blue));
    --color-link-hover:               rgb(var(--color-wp-blue-dark));

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */
   
    /* LAYOUTS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* ANONYMOUS LAYOUT */

    --anonymous-logo-bg:              var(--color-white);
    --anonymous-copy-bg:              var(--color-white);
    --anonymous-heading-color:        var(--color-sapin-red);
    --anonymous-subheading-color:     var(--color-sapin-red-bg);
    --anonymous-text-color            var(--color-dark);
    --anonymous-logo-height:          100px;
    --anonymous-bg:                   url(${ images.backgrounds[0] });
    --anonymous-bg-size:              cover;

    /* END */

    /* SIDEBAR */

    --sidebar-bg-color: var(--color-darker);
    --sidebar-logo-bg-color: var(--color-white);
    --sidebar-logo-height: 45px;
    --sidebar-label-color: rgba(var(--color-white-rgb), 0.7);
    --sidebar-border-color: var(--color);

    --sidebar-button-color: var(--color-sapin-red);
    --sidebar-button-color-active: var(--color-darker);
    --sidebar-button-color-hover: var(--color-sapin-red);
    --sidebar-button-bg-color: transparent;
    --sidebar-button-bg-color-active: var(--color-sapin-red);
    --sidebar-button-bg-color-hover: transparent;
    --sidebar-button-border-color: var(--color-sapin-red);
    --sidebar-button-border-color-active: var(--color-sapin-red);
    --sidebar-button-border-color-hover: var(--color-sapin-red);

    /* END */

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* BUTTONS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* PRIMARY BUTTON */

    --btn-primary--bg:                var(--color-sapin-yellow);
    --btn-primary--border:            var(--color-sapin-yellow);
    --btn-primary--color:             var(--color-white);
    --btn-primary--colorH:            var(--color-white);
    --btn-primary--bgH:               var(--color-sapin-yellow);
    --btn-primary--borderH:           var(--color-sapin-yellow);

    /* END */

    /* SECONDARY BUTTON */

    --btn-secondary--bg:              transparent;
    --btn-secondary--border:          var(--color-sapin-yellow);
    --btn-secondary--color:           var(--color-sapin-yellow);
    --btn-secondary--bgH:             transparent;
    --btn-secondary--borderH:         var(--color-sapin-yellow);
    --btn-secondary--colorH:          var(--color-sapin-yellow);

    /* END */

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */
  `,
};
